import { Center } from '@chakra-ui/react'
import React from 'react'

const Hiring = () => {
  return (
    <div>
        <Center>
            <img style={{width:"85%",cursor:"pointer"}} src="https://i.im.ge/2022/08/24/O5DJsq.Screenshot-4.png" alt="Screenshot_4" border="0"/>
        </Center>
    </div>
  )
}

export default Hiring
